import React from "react";
import {
  MapAreaItemDto,
  PaginatedListOfMapAreaItemDto,
  useMapAreaApi,
} from "~/api/GeneratedApi";
import { useCustomQuery } from "./useCustomQuery";

type UseMapAreasReturn = {
  mapAreas: MapAreaItemDto[];
  mapAreasLoading: boolean;
};

export function useMapAreas(): UseMapAreasReturn {
  const { getMapAreas } = useMapAreaApi();

  const { data: mapAreas, isLoading: mapAreasLoading } = useCustomQuery(
    "map-areas",
    () => getMapAreas(),
    {
      select: React.useCallback(
        (d: PaginatedListOfMapAreaItemDto) => d.results,
        [],
      ),
    },
  );

  const notUndefMapAreas = React.useMemo(
    () => mapAreas ?? ([] as MapAreaItemDto[]),
    [mapAreas],
  );

  return { mapAreas: notUndefMapAreas, mapAreasLoading };
}
